import { render, staticRenderFns } from "./add.vue?vue&type=template&id=1f7a9099&"
import script from "./add.vue?vue&type=script&lang=ts&"
export * from "./add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports